"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * PriceZoneProductPrice represents helper object for {@link InternalProductPricesDTO}.
 * It holds calculated prices in certain price zone for certain product.
 *
 * @author JMr
 */


var PriceZoneProductPrice =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(PriceZoneProductPrice, _DomainObject_1$Domai);

  /**
   * @param priceZoneId
   * @param actualRegularPrice average of internal product of category
   * @param actualMarginPrice difference between purchase and regular price
   * @param actualMarginPercentage difference between purchase and regular price in %
   * @param unitPrice actual regular price for a base unit
   */
  function PriceZoneProductPrice(priceZoneId, actualRegularPrice, actualMarginPrice, actualMarginPercentage, unitPrice) {
    var _this;

    _classCallCheck(this, PriceZoneProductPrice);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PriceZoneProductPrice).call(this));
    _this.priceZoneId = priceZoneId;
    _this.actualRegularPrice = actualRegularPrice;
    _this.actualMarginPrice = actualMarginPrice;
    _this.actualMarginPercentage = actualMarginPercentage;
    _this.unitPrice = unitPrice;
    return _this;
  }

  return PriceZoneProductPrice;
}(DomainObject_1.DomainObject);

exports.PriceZoneProductPrice = PriceZoneProductPrice;

PriceZoneProductPrice.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(PriceZoneProductPrice.name);
  return {
    priceZoneId: builder.str('internalProductId'),
    actualRegularPrice: builder.bigNum('actualRegularPrice'),
    actualMarginPrice: builder.bigNum('actualMarginPrice'),
    actualMarginPercentage: builder.bigNum('actualMarginPercentage'),
    unitPrice: builder.bigNum('unitPrice')
  };
}();